"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    UserBlock: function() {
        return UserBlock;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const UserBlock = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12 3C10.3431 3 9 4.34315 9 6C9 7.65685 10.3431 9 12 9C13.6569 9 15 7.65685 15 6C15 4.34315 13.6569 3 12 3ZM7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6C17 8.76142 14.7614 11 12 11C9.23858 11 7 8.76142 7 6ZM4.06189 21C4.55399 17.0537 7.92038 14 12 14C12.8571 14 13.6809 14.1344 14.4525 14.3827C14.9783 14.5518 15.5416 14.2627 15.7107 13.7369C15.8798 13.2112 15.5907 12.6479 15.065 12.4787C14.0979 12.1676 13.0675 12 12 12C6.47715 12 2 16.4772 2 22C2 22.5523 2.44772 23 3 23H12.6736C13.2259 23 13.6736 22.5523 13.6736 22C13.6736 21.4477 13.2259 21 12.6736 21H4.06189ZM19 17C17.8954 17 17 17.8954 17 19C17 19.1792 17.0236 19.3528 17.0677 19.518L19.518 17.0677C19.3528 17.0236 19.1792 17 19 17ZM20.9323 18.482L18.482 20.9323C18.6472 20.9764 18.8208 21 19 21C20.1046 21 21 20.1046 21 19C21 18.8208 20.9764 18.6472 20.9323 18.482ZM15 19C15 16.7909 16.7909 15 19 15C21.2091 15 23 16.7909 23 19C23 21.2091 21.2091 23 19 23C16.7909 23 15 21.2091 15 19Z",
        fill: "currentColor"
    })
}), "UserBlock");
const _default = UserBlock;
